import { StringParam, useQueryParam } from 'use-query-params'
import { ENV } from '../config'
import { useGeolocationCountry } from './geolocation'

export const useIsUserInFrance = (): boolean | null => {
  const { isLoading, data: country } = useGeolocationCountry()
  const [debugCountry] = useQueryParam('country', StringParam)

  if (isLoading) {
    return null
  }

  const isUserInFrance = country
    ? getIsUserInFrance(country, debugCountry)
    : null

  return isUserInFrance
}

const getIsUserInFrance = (country: string, debugCountry?: string | null) => {
  const FR = 'FR'
  if (ENV === 'local') {
    if (debugCountry) {
      return debugCountry === FR
    }
  }
  return country === FR
}
